// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonWrapper_wrapper__3yfMG","submitButton":"ButtonWrapper_submitButton__d_zZ_","backButton":"ButtonWrapper_backButton__1R_aO"};